import { useEffect, useState } from "react";
import Select, { components } from "react-select";

const SelectAno = (props) => {
  const Component = (props) => (
    <div style={{ border: `2px dotted #5243AA`, borderRadius: "5px", background: "#f2fcff" }}>
      <components.Group {...props} />
    </div>
  );

  const [anos, setAnos] = useState([]);
  const primeiroAno = 1980;

  useEffect(() => {
    const _anos = [];
    const ultimoAno = props.ultimoAno ?? new Date().getFullYear();
    for (let ano = primeiroAno; ano <= ultimoAno; ano++) {
      _anos.push({label: ano, value: ano});
    }

    setAnos(_anos);
  }, []);

  return (
    <Select
      isDisabled={props.disabled}
      defaultValue={props.defaultValue}
      value={props.value}
      name={props.name}
      id={props.id}
      placeholder={props.placeholder}
      components={{ Component }}
      options={anos}
      className={props.className}
      onChange={props.onChange}
      isSearchable={props.isSearchable}
      isClearable={props.isClearable}
    />
  )
};

export default SelectAno;